import React from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import routes from '#/app/routes';

const router = createHashRouter(routes);

const RouteProvider: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default React.memo(RouteProvider);
